import { FC } from "react";
import { IClassname } from "@/lib/types/classname";

export const SvgPhoto: FC<IClassname> = ({ className }) => {
  return (
    <svg
    className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.1358 16.5998L30.3024 11.0771H17.6976L15.8642 16.5998H10.8223C8.98889 16.5998 7.38464 18.1462 7.38464 19.9134V33.6097C7.38464 35.377 8.98889 36.9233 10.8223 36.9233H37.1777C39.0112 36.9233 40.6154 35.377 40.6154 33.6097V19.9134C40.6154 18.1462 39.0112 16.5998 37.1777 16.5998H32.1358Z"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 31.3845C25.4689 31.3845 26.8776 30.801 27.9163 29.7624C28.955 28.7237 29.5385 27.315 29.5385 25.8461C29.5385 24.3772 28.955 22.9685 27.9163 21.9298C26.8776 20.8911 25.4689 20.3076 24 20.3076C22.5311 20.3076 21.1224 20.8911 20.0837 21.9298C19.0451 22.9685 18.4615 24.3772 18.4615 25.8461C18.4615 27.315 19.0451 28.7237 20.0837 29.7624C21.1224 30.801 22.5311 31.3845 24 31.3845Z"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
